"use client";

import { useEffect, useRef, useState } from "react";
import { cn } from "@/lib/utils";

// Een afkorting die je kunt aantikken (C5).
//
// FP, DIS, HP en BM stonden er zonder uitleg; Joost wees erop dat de buurman ze
// moest uitleggen. De uitleg hing eerst in een title, maar dat is een
// muis-tooltip: op een telefoon - waar vrijwel iedereen op de tribune kijkt -
// gebeurt er dan niets.
//
// Het wolkje staat vast in beeld (position: fixed) en niet binnen de regel: de
// uitslagkaarten hebben afgeronde hoeken met overflow-hidden, en daar viel een
// gewoon uitklapblok aan de rand half af. Scrollen sluit het, want dan klopt de
// plek niet meer.
export function Afkorting({
  tekst,
  uitleg,
  className,
}: {
  tekst: string;
  uitleg: string;
  className?: string;
}) {
  const knop = useRef<HTMLButtonElement>(null);
  const [plek, setPlek] = useState<{ top: number; right: number } | null>(null);

  useEffect(() => {
    if (!plek) return;
    const dicht = () => setPlek(null);
    const buiten = (e: PointerEvent) => {
      if (!knop.current?.contains(e.target as Node)) dicht();
    };
    const toets = (e: KeyboardEvent) => {
      if (e.key === "Escape") dicht();
    };
    document.addEventListener("pointerdown", buiten);
    document.addEventListener("keydown", toets);
    window.addEventListener("scroll", dicht, { passive: true, capture: true });
    window.addEventListener("resize", dicht);
    return () => {
      document.removeEventListener("pointerdown", buiten);
      document.removeEventListener("keydown", toets);
      window.removeEventListener("scroll", dicht, { capture: true });
      window.removeEventListener("resize", dicht);
    };
  }, [plek]);

  // Een onbekende code heeft zichzelf als uitleg; dan valt er niets te tikken.
  if (!uitleg || uitleg === tekst) {
    return <span className={className}>{tekst}</span>;
  }

  return (
    <>
      <button
        ref={knop}
        type="button"
        aria-expanded={plek != null}
        aria-label={`${tekst}: ${uitleg}`}
        onClick={() => {
          if (plek) return setPlek(null);
          const r = knop.current!.getBoundingClientRect();
          // Rechts uitgelijnd op de afkorting: die staat bijna altijd in de
          // rechterkolom, en dan valt het wolkje niet buiten het scherm.
          setPlek({ top: r.bottom + 6, right: Math.max(8, window.innerWidth - r.right) });
        }}
        className={cn(
          "cursor-help underline decoration-dotted decoration-1 underline-offset-[3px]",
          className,
        )}
      >
        {tekst}
      </button>
      {plek && (
        <span
          role="tooltip"
          style={{ top: plek.top, right: plek.right }}
          className="fixed z-50 max-w-[16rem] rounded-lg border border-border bg-muted px-3 py-2 text-left font-sans text-xs font-normal normal-case leading-snug tracking-normal text-white shadow-lg"
        >
          {uitleg}
        </span>
      )}
    </>
  );
}
